const routes = [
  {
    path: '/cadastro/geral/base',
    name: 'basis',
    component: () => import('@/views/cadastros/base/Base.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Bases' }],
    },
  },
  {
    path: '/cadastro/geral/base/novo',
    name: 'basisNew',
    component: () => import('@/views/cadastros/base/BaseNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Base' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/base/:id/editar',
    name: 'basisUpdate',
    component: () => import('@/views/cadastros/base/BaseNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Base' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/local',
    name: 'local',
    component: () => import('@/views/cadastros/local/Local.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Localidade' }],
    },
  },
  {
    path: '/cadastro/geral/local/novo',
    name: 'localNew',
    component: () => import('@/views/cadastros/local/LocalNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Localidade' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/local/:id/editar',
    name: 'localUpdate',
    component: () => import('@/views/cadastros/local/LocalNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Localidade' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/recurso',
    name: 'resource',
    component: () => import('@/views/cadastros/recurso/Recurso.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Recurso' }],
    },
  },
  {
    path: '/cadastro/geral/recurso/novo',
    name: 'resourceNew',
    component: () => import('@/views/cadastros/recurso/RecursoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Recurso' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/recurso/:id/editar',
    name: 'resourceUpdate',
    component: () => import('@/views/cadastros/recurso/RecursoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Recurso' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/distrito',
    name: 'district',
    component: () => import('@/views/cadastros/distrito/Distrito.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Distrito' }],
    },
  },
  {
    path: '/cadastro/geral/distrito/novo',
    name: 'districtNew',
    component: () => import('@/views/cadastros/distrito/DistritoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Distrito' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/distrito/:id/editar',
    name: 'districtUpdate',
    component: () => import('@/views/cadastros/distrito/DistritoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Distrito' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/contrato',
    name: 'contract',
    component: () => import('@/views/cadastros/contrato/Contrato.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Contrato' }],
    },
  },
  {
    path: '/cadastro/geral/contrato/novo',
    name: 'contractNew',
    component: () => import('@/views/cadastros/contrato/ContratoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Contrato' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/contrato/:id/editar',
    name: 'contractUpdate',
    component: () => import('@/views/cadastros/contrato/ContratoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Contrato' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/geral/unidade',
    name: 'unity',
    component: () => import('@/views/cadastros/unidade/Unidade.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Unidade' }],
    },
  },
  {
    path: '/cadastro/geral/unidade/novo',
    name: 'unityNew',
    component: () => import('@/views/cadastros/unidade/UnidadeNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Unidade' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/geral/unidade/:id/editar',
    name: 'unityUpdate',
    component: () => import('@/views/cadastros/unidade/UnidadeNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Geral' }, { title: 'Unidade' }, { title: 'Editar' }],
    },
  },
]

export default routes
